"use strict";
// generated-repayment-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const tasks_1 = require("../../tasks");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    loanProductSlug: zod_1.z.string().describe('Loan product slug'),
    creditFacilitySlug: zod_1.z.string().nullable().describe('Credit facility slug'),
    rawExternalReceivableIdField: zod_1.z
        .string()
        .describe('Specifies the field in the raw tape that identifies how to map to associated receivable'),
    rawRepaymentTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Raw repayment tape artifact slug'),
    generatedLoanTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Generated loan tape artifact slug'),
});
exports.nodeType = 'file_generatedRepaymentTape';
exports.IntermediateRecordConfigSchema = tasks_1.TapeBuilderTaskSchema.and(exports.UIConfigSchema.omit({
    artifactSlug: true,
    loanProductSlug: true,
    creditFacilitySlug: true,
}).extend({
    externalReceivableIdField: zod_1.z
        .string()
        .describe('Sanitized version of rawExternalReceivableIdField, easier to use with sanitized data'),
}));
exports.artifactType = 'generatedRepaymentTape';
//# sourceMappingURL=types.js.map